import React, { Suspense } from 'react';
import Loading from '@components/Loading';

const SuspenseComponent = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default SuspenseComponent;
